import React from 'react';
import { CUSTOMER_TYPE_LABELS, CUSTOMER_TYPE_COLORS } from '../../lib/utils';

export default function CustomerTypeBadge({ customerType, className = '' }) {
  const label = CUSTOMER_TYPE_LABELS[customerType] || customerType;
  const colors = CUSTOMER_TYPE_COLORS[customerType] || CUSTOMER_TYPE_COLORS.basic;
  
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${colors.bg} ${colors.text} ${colors.border} ${className}`}
      data-testid={`customer-type-badge-${customerType}`}
    >
      {label}
    </span>
  );
}
